export const CNAES_SUBCLASSES_URL =
  'https://servicodados.ibge.gov.br/api/v2/cnae/subclasses';

/** RFB CNPJ open-data CNAE table — parity reference for fiscal subclass codes. */
export const CNAES_RFB_CNAES_ZIP_BASE_URL =
  'https://dadosabertos.rfb.gov.br/CNPJ/dados_abertos_cnpj';

export const CNAES_GOLDEN_DESENVOLVIMENTO_PROGRAMAS = '6201501';
export const CNAES_GOLDEN_WEB_DESIGN = '6201502';
export const CNAES_MIN_SUBCLASSES = 1200;
export const CNAES_MAX_SUBCLASSES = 1500;
